import React, { useMemo, useState, useCallback } from "react";

import InitialDataListPage from "../components/InitialDataListPage";
import { updateData } from "../../../../utils/SamuiUtils";

const getDocTypeLabel = (docType) => {
  const value = Number(docType);
  switch (value) {
    case 1:
      return "สินค้า";
    case 2:
      return "บริการ";
    case 3:
      return "โปรเจค";
    case 4:
      return "ของขวัญ";
    case 5:
      return "โอที";
    default:
      return docType || "-";
  }
};

const ItemGroupMain = ({
  masterList = [],
  name,
  onPageInsert,
  onRowSelected,
  callInitialize,
}) => {
  const [statusFilter, setStatusFilter] = useState("Y");
  const [togglingId, setTogglingId] = useState(null);

  const handleToggleShowInWork = useCallback(async (item) => {
    if (togglingId === item.Group_Id) return;
    setTogglingId(item.Group_Id);
    try {
      await updateData(
        "Tb_Set_ItmGroup",
        { IsShowInWork: Number(item.IsShowInWork) === 1 ? 0 : 1 },
        { Group_Id: item.Group_Id }
      );
      if (callInitialize) await callInitialize();
    } catch (e) {
      console.error("Toggle IsShowInWork failed", e);
    } finally {
      setTogglingId(null);
    }
  }, [togglingId, callInitialize]);

  const filteredMasterList = useMemo(() => {
    if (!Array.isArray(masterList)) return [];
    return masterList.filter((m) => String(m?.Group_Status ?? "Y") === String(statusFilter));
  }, [masterList, statusFilter]);
  const columns = useMemo(
    () => [
      {
        key: "index",
        header: "#",
        width: "6%",
        align: "center",
        render: (_item, _index, { startIndex, itemIndex }) =>
          startIndex + itemIndex + 1,
      },
      {
        key: "Group_Code",
        header: "รหัสหมวดหมู่สินค้า",
        width: "18%",
        align: "center",
        render: (item) => item.Group_Code || "-",
      },
      {
        key: "Group_Name",
        header: "ชื่อหมวดหมู่สินค้า",
        width: "40%",
        align: "start",
        render: (item) => item.Group_Name || "-",
      },
      {
        key: "Doc_Type",
        header: "ประเภทเอกสาร",
        width: "18%",
        align: "center",
        render: (item) => getDocTypeLabel(item.Doc_Type),
      },
      {
        key: "IsShowInWork",
        header: "Assign Job",
        width: "10%",
        align: "center",
        render: (item) => {
          const isOn = Number(item.IsShowInWork) === 1;
          const isLoading = togglingId === item.Group_Id;
          return (
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); handleToggleShowInWork(item); }}
              disabled={isLoading}
              style={{
                width: 44, height: 24, borderRadius: 12, border: "none", cursor: isLoading ? "wait" : "pointer",
                backgroundColor: isOn ? "#16a34a" : "#d1d5db",
                position: "relative", transition: "background-color 0.2s",
              }}
              title={isOn ? "คลิกเพื่อปิด" : "คลิกเพื่อเปิด"}
            >
              <span style={{
                position: "absolute", top: 2, left: isOn ? 22 : 2,
                width: 20, height: 20, borderRadius: "50%", backgroundColor: "#fff",
                transition: "left 0.2s", display: "block",
              }} />
            </button>
          );
        },
      },
      {
        key: "Group_Status",
        header: "สถานะ",
        width: "12%",
        align: "center",
        render: (item) =>
          item.Group_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
      },
      {
        key: "actions",
        header: "แก้ไข",
        width: "6%",
        align: "center",
        isAction: true,
        render: (item, _index, { triggerRowSelected }) => (
          <button
            onClick={(event) => {
              event.stopPropagation();
              triggerRowSelected(item);
            }}
            className="btn btn-sm"
            title="แก้ไข"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#fff3e0",
              color: "#EF6C00",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(event) => {
              event.currentTarget.style.backgroundColor = "#EF6C00";
              event.currentTarget.style.color = "#fff";
            }}
            onMouseOut={(event) => {
              event.currentTarget.style.backgroundColor = "#fff3e0";
              event.currentTarget.style.color = "#EF6C00";
            }}
            type="button"
          >
            <i className="fas fa-edit" />
          </button>
        ),
      },
    ],
    [togglingId, handleToggleShowInWork]
  );

  const getSearchValues = useMemo(
    () => (item) => [
      item?.Group_Code,
      item?.Group_Name,
      getDocTypeLabel(item?.Doc_Type),
      item?.Group_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
    ],
    []
  );

  const customHeader = (
    <div className="d-flex align-items-center" style={{ width: '100%', gap: 16, flexWrap: 'nowrap' }}>
      <label className="mb-0" style={{ fontWeight: 700, fontSize: 13, marginRight: 8, minWidth: 150, whiteSpace: 'nowrap' }}>สถานะการใช้งาน</label>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 0 }}>
          <input style={{ accentColor: '#E13F57', width: 16, height: 16 }} className="form-check-input" type="radio" name="groupStatusFilter" id="filterGroupActive" value="Y" checked={statusFilter === "Y"} onChange={() => setStatusFilter("Y")} />
          <span style={{ fontSize: 14 }}>ใช้งาน</span>
        </label>

        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 0 }}>
          <input style={{ accentColor: '#E13F57', width: 16, height: 16 }} className="form-check-input" type="radio" name="groupStatusFilter" id="filterGroupInactive" value="N" checked={statusFilter === "N"} onChange={() => setStatusFilter("N")} />
          <span style={{ fontSize: 14 }}>ไม่ใช้งาน</span>
        </label>
      </div>
    </div>
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/tbsetitmgroup"
      data={filteredMasterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      searchPlaceholder={`ค้นหา${name || "หมวดหมู่สินค้า"}...`}
      fieldMappings={{ no: "Group_Id" }}
      getRowId={(item) => item?.Group_Id}
      customHeader={customHeader}
    />
  );
};

export default ItemGroupMain;
